export const Translations_ro = {
    "welcomePageTitle": "Alege ",
    "lockerName": "Numer locker",
    "lockerId": "Id Locker",
    "address": "Adresa",
    "selectBtn": "Alege easybox",
    "select": "Selecteaza...",
    "county": "Judet",
    "city": "Oras",
    "easyboxNameStreet": "Nume easybox / strada...",
    "backToLockerList": "< Inapoi la lista",
    "favouriteLocker": "Salveaza ca favorit",
    "removeFavouriteLocker": "Sterge favorit",
    "openOnGoogleMaps": "Deschide in Google Maps",
    "monday": "Luni",
    "tuesday": "Marti",
    "wednesday": "Miercuri",
    "thursday": "Joi",
    "friday": "Vineri",
    "saturday": "Sambata",
    "sunday": "Duminica",
    "non-stop": "non-stop",
    "lockerSchedule": "Program",
    "seeOnMap": "Vezi harta",
    "locationDisclaimer": "Va rugam sa aveti locatia activa si sa permiteti accesul cand browserul/deviceul necesita permisiuni de localizare.",
    "findMeOnMap": "Arata-ma pe harta",
    "searchFilters": "Filtre de cautare",
    "locationError1": "Geolocalizarea nu functioneaza pe acest browser.",
    "locationError2": "Eroare de localizare: Acces nepermis!",
    "locationError3": "Eroare de localizare: Pozitia este indisponibila!",
    "clientNotFoundErrorMsg": "Eroare! Clientul nu a fost gasit!",
    "sdkNotFoundErrorMsg": "Eroare! Locker Plugin SDK nu a fost gasit!",
    "search": "Cauta orice despre easybox",
    "searchBy": "Poti cauta dupa:",
    "easyboxName": "Nume easybox",
    "street": "Strada",
    "showEasyboxList": "Vezi lista de easybox-uri",
    "hideEasyboxList": "Ascunde lista de easybox-uri",
    "searchError1": "Textul trebuie sa aiba intre ${minLimit} si ${maxLimit} caractere!",
    "searchError2": "Textul nu poate contine caracterul special: ${notAllowedSpecial}",
    "home": "Acasa",
    "work": "Serviciu",
    "onlyPOSLockers": "Doar easyboxuri cu POS",
    "advancedFilters": "Filtre",
    "posAtLocation": "POS la locatie:",
    "yes": "Da",
    "no": "Nu",
    "showAllTheLockersInArea": "Cauta toate easybox-urile din zona",
    "showSelectedLocker": "Vezi easybox-ul selectat",
    "hideSelectedLocker": "Ascunde easybox-ul selectat",
    "noEasyboxesFound": "Nu am gasit nici un easybox, va rugam sa va rafinati cautarea."
}